import React from 'react';

export const BtnRound = props => {
  const { onClick, className, children } = props;

  return (
    <button
      className={`rounded-full bg-primary shadow flex items-center justify-center ${className}`}
      style={{ width: 42, height: 42 }}
      onClick={() => onClick()}
    >
      {children}
    </button>
  );
};
